module.exports = __webpack_public_path__ + "usflag.a8acd268.png";